import {CartData} from "./CartProcessor";

/**
 * Keeps the scale prices of the format dialog up to date.
 *
 * The answer of a changed quantity (the cart task add2cart) carries the scale prices of that
 * format rendered anew by the server, `scaleprice: {imagetypeid, price, html}`: the price in the
 * head of the format (imageset/scaleprice/price) and the block with the tiers and where the cart
 * stands (imageset/scaleprice/default). They take the place of the ones in the dialog, so the
 * marked tier, the sentence and the bar follow the cart without the script knowing the prices.
 *
 * When the tier which applies changes (data-tier of the block), the live region of the dialog
 * (.eventgallery-scale-status) says the short sentence of the new block (data-announce), once:
 * "Now 1.49 EUR per item". The cart line of the dialog says the count and the subtotal anyway.
 */
export class ScalePriceView {
    static SCALE_SELECTOR = '.eg-scale';
    static PRICE_SELECTOR = '.eg-format__price';
    static FORMAT_SELECTOR = '.eg-format';
    static STATUS_SELECTOR = '.eventgallery-scale-status';

    static update(root: ParentNode, data: CartData | null) {
        const scale = data ? data.scaleprice : null;
        if (!scale || !scale.imagetypeid) {
            return;
        }

        const input = root.querySelector('.eventgallery-cartquantity[data-imagetypeid="' + parseInt(String(scale.imagetypeid), 10) + '"]');
        const format = input ? input.closest(ScalePriceView.FORMAT_SELECTOR) : null;
        if (!format) {
            return;
        }

        const block = format.querySelector(ScalePriceView.SCALE_SELECTOR);
        const tierBefore = block ? block.getAttribute('data-tier') : null;
        if (block && scale.html) {
            block.outerHTML = scale.html;
        }

        const price = format.querySelector(ScalePriceView.PRICE_SELECTOR);
        if (price && scale.price) {
            price.outerHTML = scale.price;
        }

        const now = format.querySelector(ScalePriceView.SCALE_SELECTOR);
        const status = root.querySelector(ScalePriceView.STATUS_SELECTOR);
        if (now && status && tierBefore !== null && now.getAttribute('data-tier') !== tierBefore) {
            status.textContent = now.getAttribute('data-announce') || '';
        }
    }
}
